import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47b8db44"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "orderbook" };
const _hoisted_2 = { class: "list_outer" };
import TradeTitle from '@/materials/atoms/TradeTitle.vue';
import OrderBookContract from '@/components/organisms/main/trade/orderbook/OrderBookContract.vue';
import OrderBookHeader from '@/components/organisms/main/trade/orderbook/OrderBookHeader.vue';
import OrderBookList from '@/components/organisms/main/trade/orderbook/OrderBookList.vue';
import { useStore } from '@/store/store';
import { useOrderBook, orderBookSubscriber } from '@/logics/orderbook';
import { onMounted, onUnmounted, watch } from 'vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        base: null,
        quote: null,
        isAuth: { type: Boolean },
        latestValue: null
    },
    setup(__props) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const store = useStore();
            const { format, ORDERBOOK_FIELDS } = useMessage();
            const { getOrderBook, orderBookSpread } = useOrderBook();
            const { buy, sell } = (([__temp, __restore] = _withAsyncContext(() => getOrderBook(store.getters.symbol.pair))),
                __temp = yield __temp,
                __restore(),
                __temp);
            const { subscribe, unsubscribe, buyList, sellList } = orderBookSubscriber(buy, sell, store.state.symbol.pair);
            onMounted(() => {
                subscribe();
                if (!props.isAuth) {
                    setTimeout(unsubscribe, process.env.VUE_APP_UNSUBSCRIBE * 1000);
                }
            });
            onUnmounted(unsubscribe);
            watch(() => store.state.openList, () => __awaiter(this, void 0, void 0, function* () {
                getOrderBook(store.getters.symbol.pair).then((res) => {
                    buyList.value = res.buy;
                    sellList.value = res.sell;
                });
            }));
            const decimal = ((_a = store.state.currencyPairInfo.find((obj) => obj.pair === store.getters.symbol.pair)) === null || _a === void 0 ? void 0 : _a.decimal) || 0;
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createVNode(TradeTitle, {
                        title: String(_unref(format)(_unref(ORDERBOOK_FIELDS).TITLE))
                    }, null, 8, ["title"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(OrderBookHeader, {
                            quote: props.quote,
                            base: props.base
                        }, null, 8, ["quote", "base"]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["list_outer", _unref(sellList).length === 0 ? 'lists' : ''])
                        }, [
                            (_unref(sellList).length !== 0)
                                ? (_openBlock(), _createBlock(OrderBookList, {
                                    key: 0,
                                    class: "lists",
                                    list: _unref(sellList),
                                    trade: "sell",
                                    id: "sell"
                                }, null, 8, ["list"]))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createVNode(OrderBookContract, {
                            class: "contract_outer",
                            latestValue: props.latestValue,
                            spread: _unref(orderBookSpread)(_unref(buyList), _unref(sellList), _unref(decimal))
                        }, null, 8, ["latestValue", "spread"]),
                        _createElementVNode("div", _hoisted_2, [
                            (_unref(buyList).length !== 0)
                                ? (_openBlock(), _createBlock(OrderBookList, {
                                    key: 0,
                                    class: "lists",
                                    list: _unref(buyList),
                                    trade: "buy",
                                    id: "buy"
                                }, null, 8, ["list"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ], 64));
            };
        });
    }
});
